var exports = {
  "WB": "PersonalNotesWelcomeSection.module__welcomeSection___a2Robz",
  "H": "PersonalNotesWelcomeSection.module__avatarContainer___a2Robz",
  "oJ": "PersonalNotesWelcomeSection.module__avatarBackground___a2Robz",
  "my": "PersonalNotesWelcomeSection.module__avatar___a2Robz",
  "DD": "PersonalNotesWelcomeSection.module__title___a2Robz",
  "fF": "PersonalNotesWelcomeSection.module__dividerContainer___a2Robz",
  "K8": "PersonalNotesWelcomeSection.module__dividerSvg___a2Robz",
  "h_": "PersonalNotesWelcomeSection.module__description___a2Robz",
};

module.exports = exports;
